import React, { Fragment } from "react";
import { Modal, ModalBody } from "reactstrap";
import { withTranslation } from "react-i18next";
import "./ChatModal.scss";
import { addDefaultStaffRounded } from "utils";
import defaultStaffRounded from "assets/images/staff-default-rounded.png";

function UsersModal(props) {
  const { users = [], isOpen, onClose } = props;

  return (
    <Fragment>
      <Modal
        isOpen={isOpen}
        toggle={onClose}
        className="modal-dialog-centered modal-width-660 new-grop-modal"
        modalClassName="custom-modal"
      >
        <span className="close-btn" onClick={onClose}>
          <img src={require("assets/images/cross.svg").default} alt="close" />
        </span>
        <ModalBody>
          <ul className={"modal-employee-list group-list mb-0"}>
            {users.map((staff, index) => {
              return (
                <li key={staff?.id ?? index}>
                  <div className="ch-checkbox no-checkbox">
                    <label>
                      <span>
                        <img
                          src={staff.profilePic || defaultStaffRounded}
                          alt="profile-pic"
                          onError={(e) => addDefaultStaffRounded(e, staff)}
                        />
                        <div> {staff.name}</div>
                      </span>
                    </label>
                  </div>
                </li>
              );
            })}
          </ul>
        </ModalBody>
      </Modal>
    </Fragment>
  );
}

export default withTranslation()(UsersModal);
